// @module C3.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.PDP.CompleteYourKitItems.Collection'
,	[
	   'Item.Collection'	
    ]
, function (
	ItemCollection
)
{
    'use strict';

	// @class C3.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return ItemCollection.extend({
    initialize: function(options) {
       // this.searchApiMasterOptions = Configuration.searchApiMasterOptions.correlatedItems;
       this.searchApiMasterOptions= {
        fieldset : 'details'
       }
       // console.log(options)
        /*this.itemsIds = _.isArray(options.itemsIds)
            ? _.sortBy(options.itemsIds, function(id) {
                  return id;
              })
            : [options.itemsIds];
        this.responseResults =  _.isArray(options.responseResults)
            ? _.sortBy(options.responseResults, function(id) {
                  return id;
              })
            : [options.responseResults];*/  
        this.itemsIds = options.itemsIds;
        this.parentItemInfo = options.parentItemInfo;
        this.responseResults = options.responseResults; 
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        //console.log(this.itemsIds)
        return this.fetch({ data: { id: this.itemsIds.join(',') } });
    },

    // http://backbonejs.org/#Model-parse
    parse: function(response) {
        const original_items = _.compact(response.items) || [];
        const self = this;
        var items = [];

        var selector_data = []
         _.each(this.itemsIds, function(ids) {
            selector_data = _.find(original_items, function(obj) {
                return obj.internalid == ids;
            });
            items.push(selector_data)
        });
         
        var final_items = _.compact(items)
        return _.toArray(final_items);
    }

	});
});
